export const IUBENDA_PURPOSE = {
  NECESSARY: 1,
  BASIC_INTERACTIONS: 2,
  EXPERIENCE_ENHANCEMENT: 3,
  MEASUREMENT: 4,
  TARGETING_AND_ADVERTISING: 5
};

const POLL_INTERVAL_MS = 500;

function controlsInstalled() {
  return !!(window._iub && window._iub.csConfiguration);
}

function currentPurposes() {
  const cs = window._iub.cs;
  // getPreferences reflects a choice made on this page; cs.consent can still hold the one read at load.
  const preferences = (cs && cs.api && cs.api.getPreferences && cs.api.getPreferences()) || (cs && cs.consent);
  return (preferences && preferences.purposes) || {};
}

export function hasPurposeConsent(purpose) {
  if (!controlsInstalled()) {
    return true;
  }
  return !!currentPurposes()[purpose];
}

function apiLoaded() {
  const cs = window._iub.cs;
  return !!(cs && cs.api && cs.api.setPreferences);
}

function setPurposeConsent(purpose) {
  window._iub.cs.api.setPreferences({ purposes: { ...currentPurposes(), [purpose]: true } }, true);
}

export function grantPurposeConsent(purpose) {
  if (!controlsInstalled()) {
    return;
  }
  if (apiLoaded()) {
    setPurposeConsent(purpose);
    return;
  }

  // iubenda_cs.js loads async, so a quick tap can beat it; grant as soon as it's there.
  const timer = setInterval(() => {
    if (apiLoaded()) {
      clearInterval(timer);
      setPurposeConsent(purpose);
    }
  }, POLL_INTERVAL_MS);
}

export function onConsentGranted(purpose, callback) {
  if (!controlsInstalled()) {
    callback();
    return;
  }

  let called = false;
  const run = () => {
    if (called || !hasPurposeConsent(purpose)) {
      return false;
    }
    called = true;
    callback();
    return true;
  };

  if (run()) {
    return;
  }

  // No cut-off: a viewer can take minutes to find the banner, and a callback added after
  // iubenda has loaded isn't guaranteed to be called.
  const timer = setInterval(() => {
    if (run()) {
      clearInterval(timer);
    }
  }, POLL_INTERVAL_MS);

  const callbacks = window._iub.csConfiguration.callback = window._iub.csConfiguration.callback || {};
  const previous = callbacks.onPreferenceExpressed;
  callbacks.onPreferenceExpressed = function (preference) {
    if (previous) {
      previous(preference);
    }
    run();
  };
}
